import { render, staticRenderFns } from "./BetaTag.vue?vue&type=template&id=b7f420d4&scoped=true"
import script from "./BetaTag.vue?vue&type=script&lang=js"
export * from "./BetaTag.vue?vue&type=script&lang=js"
import style0 from "./BetaTag.vue?vue&type=style&index=0&id=b7f420d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f420d4",
  null
  
)

export default component.exports